import { useCallback } from 'react';
import { useBoolean } from 'ahooks';
import { message } from 'antd';
import { AxiosError } from 'axios';

import { apiGet } from 'api';

import { useGetHeaders } from '../useGetHeaders';

export const useDownloadCSV = (url: string): [() => void, { loading: boolean }] => {
  const [loading, { setTrue, setFalse }] = useBoolean(false);

  const headers = useGetHeaders();

  const downloadCSV = useCallback(async () => {
    try {
      setTrue();
      const response = await apiGet<string>({ url, headers });

      const blob = new Blob([response.data], { type: 'text/csv' });
      const href = window.URL.createObjectURL(blob);

      const contentDisposition = response.headers['content-disposition'];

      const filename = contentDisposition ? contentDisposition.replace('attachment; filename=', '').replaceAll('"', '') : 'Offer Matches';

      const link = document.createElement('a');
      link.href = href;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (err) {
      const error = err as AxiosError<{ message: string }>;
      message.error(error.response?.data.message);
    } finally {
      setFalse();
    }
  }, [url]);

  return [downloadCSV, { loading }];
};
